import React from "react";
import LegalShell, { Section } from "@/pages/LegalShell";

export default function CancellationPage() {
    return (
        <LegalShell
            overline="Politique d'annulation"
            title="Annulations, retards et remboursements."
            subtitle="Cette page résume les règles applicables en cas d'annulation d'une mission, de désistement d'un professionnel ou de litige financier. Les Conditions Générales de Vente signées lors du devis restent le document de référence."
            cta={{
                title: "Consulter les CGU / CGV complètes",
                text: "Le document juridique intégral, téléchargeable en PDF.",
                to: "/cgu",
                label: "Voir les CGU / CGV",
            }}
        >
            <Section title="Annulation par le client" id="annulation-client">
                <ul className="list-disc pl-6 space-y-1.5">
                    <li>
                        <b>Avant sélection d'un candidat</b> : la mission peut être annulée
                        librement. L'acompte réglé est intégralement remboursé, sous déduction
                        d'éventuels frais de dossier explicitement mentionnés dans le devis.
                    </li>
                    <li>
                        <b>Après sélection d'un candidat, plus de 72 h avant le début</b> :
                        annulation possible, l'acompte est remboursé à hauteur de 70 %.
                    </li>
                    <li>
                        <b>Entre 72 h et 24 h avant le début</b> : l'acompte est conservé pour
                        indemniser la préparation logistique et le professionnel bloqué.
                    </li>
                    <li>
                        <b>Moins de 24 h avant le début</b> : la totalité de la mission reste
                        due, sauf motif légitime documenté (cas de force majeure).
                    </li>
                </ul>
            </Section>

            <Section title="Désistement du professionnel" id="desistement-pro">
                <p>
                    Un désistement de dernière minute par un professionnel entraîne :
                </p>
                <ul className="list-disc pl-6 space-y-1.5">
                    <li>La rediffusion urgente de la mission à d'autres profils compatibles à proximité</li>
                    <li>La suspension temporaire du profil du professionnel désistant, le temps de l'instruction</li>
                    <li>Une éventuelle inscription au taux d'annulation du professionnel, visible pour les futurs clients</li>
                </ul>
                <p>
                    Nous distinguons systématiquement les désistements pour motif légitime
                    (arrêt maladie justifié, deuil, cas de force majeure) des désistements de
                    convenance. Les premiers ne sont pas sanctionnés.
                </p>
            </Section>

            <Section title="Retard sur mission" id="retard">
                <p>
                    Tout retard supérieur à 15 minutes doit être signalé via la{" "}
                    <b>messagerie mission</b>. Un retard non justifié récurrent peut entraîner
                    une note défavorable et, à terme, la suspension du profil.
                </p>
            </Section>

            <Section title="Validation des heures et litiges" id="litiges-heures">
                <p>
                    À la fin d'une mission, le professionnel déclare ses heures effectivement
                    travaillées via son espace. Le client dispose d'un délai pour valider,
                    contester ou proposer un ajustement. En cas de désaccord persistant, notre
                    équipe intervient en médiation avec les preuves fournies par les deux parties
                    (messagerie, éventuel pointage géolocalisé consenti, échanges e-mail).
                </p>
                <p>
                    À défaut d'accord, seule la voie judiciaire permet de trancher — les
                    tribunaux compétents sont ceux de Lyon.
                </p>
            </Section>

            <Section title="Remboursements et avoirs" id="remboursements">
                <p>
                    Les remboursements sont effectués via le canal de paiement d'origine
                    (Stripe) dans un délai maximum de 14 jours ouvrés à compter de l'accord
                    entre les parties. Un avoir peut être proposé en alternative, valable
                    12 mois sur toute future mission.
                </p>
            </Section>

            <Section title="Force majeure" id="force-majeure">
                <p>
                    En cas de force majeure au sens de l'article 1218 du Code civil (événement
                    imprévisible, irrésistible, extérieur), aucune des parties ne peut être
                    tenue responsable de l'inexécution de la mission. Les sommes versées sont
                    intégralement remboursées ou transformées en avoir, au choix du client.
                </p>
            </Section>
        </LegalShell>
    );
}
